import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=44a7e935&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../../less/feedback.less?vue&type=style&index=0&id=44a7e935&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a7e935",
  null
  
)

export default component.exports